<template>
  <div class="col-12 d-flex flex-column align-items-center p-0 m-0">
    <div class="col-12 m-0 p-0 mt-4">
      <div class="col-12 m-0 p-0 mt-2">
        <b-form-group this.idInfoModal label="Nombre">
          <b-form-input
            v-model.trim="$v.name.$model"
            :state="validateName"
            size="lg"
            class="redondo-8 xxl"
            trim
          ></b-form-input>
          <b-form-invalid-feedback
            :state="!$v.name.$dirty ? null : $v.name.required"
          >
            <span class="icon icon-info"></span> Obligatorio
          </b-form-invalid-feedback>
        </b-form-group>
      </div>

      <div class="col-12 m-0 p-0 mt-2">
        <b-form-group this.idInfoModal label="Línea de negocio">
          <b-form-select
            v-model="$v.pro_line_deal_id.$model"
            :options="lineDeals.data"
            :state="validateLineDealID"
            value-field="id"
            text-field="name"
            size="lg"
            class="redondo-8 xxl"
          >
            <b-form-select-option :value="null">
              Asigna una linea de Negocio
            </b-form-select-option>
          </b-form-select>
          <b-form-invalid-feedback
            :state="
              !$v.pro_line_deal_id.$dirty ? null : $v.pro_line_deal_id.required
            "
          >
            <span class="icon icon-info"></span> Obligatorio
          </b-form-invalid-feedback>
        </b-form-group>
      </div>

      <div class="col-12 m-0 p-0 mt-2">
        <label class="col-form-label pt-0 flex flex-column">
          Sub Escenarios:
        </label>
        <b-input-group size="lg" class="mb-3">
          <b-form-input
            v-on:keyup.enter="crearSubEscenario"
            v-model.trim="subEscenarioSeleccionado.name"
            :state="!subScenarioRepetidoStado ? null : false"
            class="redondo-8 mr-2"
          ></b-form-input>
          <b-input-group-append>
            <b-button
              @click="crearSubEscenario"
              size="lg"
              text="Button"
              class="add-btn redondo-8"
            >
              {{ this.editarSubScenario ? "Editar" : "Agregar" }}
            </b-button>
          </b-input-group-append>
          <b-form-invalid-feedback :state="!subScenarioRepetidoStado">
            <span class="icon icon-info"></span> Escenario repetido
          </b-form-invalid-feedback>
        </b-input-group>
        <div
          class="border-informacion border-punteado"
          v-if="this.scenario.sub_scenarios.length > 0"
        >
          <span
            type="button"
            class="
              btn btn-primary
              border-none
              color-bg-info color-text-info
              m-2
              pr-1
            "
            v-for="(sub_scenario, index) in this.scenario.sub_scenarios"
            :key="index"
            @dblclick="seleccionarSubEscenario(sub_scenario)"
          >
            {{ sub_scenario.name }}
            <span
              class="badge badge-trans color-info-lf mr-0"
              style="font-size: 12px"
              @click="eliminarSubEscenario(index, sub_scenario)"
              >x</span
            >
          </span>
        </div>
      </div>

      <div class="col-12 m-0 p-0 mt-2" v-if="scenario.sub_scenarios">
        <label class="col-form-label pt-0 flex flex-column">
          Cargos en Sub - Escenarios:
        </label>
        <b-overlay :show="loadingCargos">
          <sub-scenario ref="sub-scenario"></sub-scenario>
          <template #overlay>
            <OverlayButton clase="overlay-md"></OverlayButton>
          </template>
        </b-overlay>
      </div>
    </div>
    <div class="mt-4 d-flex">
      <SaveModal
        :disabled="this.$v.$invalid"
        @click="guardar"
        :loading="loadingSave"
      >
        Guardar cambios
      </SaveModal>
      <CancelModal
        @click="cancelar"
        :loading="loadingCancel"
        v-if="this.id == null"
      >
        Cancelar
      </CancelModal>
      <DelModal :loading="loadingDel" @click="eliminar" v-else>
        Borrar {{ textDel }}
      </DelModal>
    </div>
  </div>
</template>
<script>
const { required } = require("vuelidate/lib/validators");
import { mapActions, mapState } from "vuex";
import SaveModal from "@/components/core/button/save-modal.vue";
import CancelModal from "@/components/core/button/cancel-modal.vue";
import DelModal from "@/components/core/button/del-modal.vue";
import SubScenario from "./sub-scenario.vue";
import OverlayButton from "@/components/core/overlay/overlay-button.vue";
export default {
  name: "scenario-form",
  components: { SaveModal, CancelModal, DelModal, SubScenario, OverlayButton },
  computed: {
    ...mapState("modScenarios", [
      "scenarioselected",
      "lineDeals",
      "scenario",
      "subScenario",
      "loadingCargos",
      "cargos",
    ]),

    validateName() {
      return !this.$v.name.$dirty
        ? null
        : !this.$v.name.$error
        ? null
        : !this.$v.name.$error;
    },
    validateLineDealID() {
      return !this.$v.pro_line_deal_id.$dirty
        ? null
        : !this.$v.pro_line_deal_id.$error
        ? null
        : !this.$v.pro_line_deal_id.$error;
    },
  },
  props: {
    textDel: {
      default: "",
      type: String,
    },
    loadingSave: {
      default: false,
      type: Boolean,
    },
    loadingCancel: {
      default: false,
      type: Boolean,
    },
    loadingDel: {
      default: false,
      type: Boolean,
    },
    disabled: {
      default: false,
      type: Boolean,
    },
  },
  emits: ["guardar", "cancelar"],
  data() {
    return {
      id: null,
      name: null,
      pro_line_deal_id: null,
      sub_scenarios: [],
      subEscenarioSeleccionado: {
        id: null,
        name: null,
        pro_scene_id: null,
        position_sub_scenario: [],
      },
      subScenarioRepetidoStado: false,
      editarSubScenario: false,
    };
  },
  validations: {
    name: {
      required,
    },
    pro_line_deal_id: {
      required,
    },
  },
  beforeMount() {
    this.setData();
  },
  methods: {
    ...mapActions("modScenarios", [
      "actSetScenario",
      "actLineDeals",
      "actScenarios",
      "actSaveScenario",
      "actUpdateScenario",
      "actDeleteScenario",
      "actSetSubEscenarios",
      "actPushSubEscenarios",
      "actDelSubEscenarios",
    ]),

    setData() {
      this.id = this.scenario.id ? this.scenario.id : null;
      this.name = this.scenario.name ? this.scenario.name : null;
      this.pro_line_deal_id = this.scenario.pro_line_deal_id
        ? this.scenario.pro_line_deal_id
        : null;
      this.sub_scenarios = this.scenario.sub_scenarios;
    },

    guardar() {
      // Revalidar formulario
      this.$v.$touch();

      if (this.validarFormulario()) {
        return false;
      }
      if (this.validarSubScenarios()) {
        return false;
      }
      if (this.validarCargos()) {
        return false;
      }

      this.guardarEstadoScenario();

      this.$emit("guardar");
    },

    cancelar() {
      this.limpiarEstadoScenario();
      this.$emit("cancelar");
    },

    eliminar() {
      this.$emit("eliminar");
    },

    validarFormulario() {
      return this.$v.$invalid;
    },

    validarSubScenarios() {
      return false;
    },

    validarCargos() {
      return false;
    },

    getDataScenario() {
      return {
        id: this.id,
        name: this.$v.name.$model,
        line_deal: this.scenario.line_deal
          ? this.scenario.line_deal
          : this.lineDeals.data.find(
              (item) => item.id == this.$v.pro_line_deal_id.$model
            ),
        pro_line_deal_id: this.$v.pro_line_deal_id.$model,
        sub_scenarios: this.scenario.sub_scenarios,
      };
    },

    guardarEstadoScenario() {
      let scenario = this.getDataScenario();
      this.actSetScenario(scenario);
      return true;
    },

    limpiarEstadoScenario() {
      return true;
    },

    crearSubEscenario() {
      if (this.editarSubScenario) {
        if (!this.nombreSubScenarioEsInValido()) {
          this.actSetSubEscenarios(this.subEscenarioSeleccionado);
        }
      } else {
        if (!this.nombreSubScenarioEsInValido()) {
          if (!this.subScenarioRepetido()) {
            this.subEscenarioSeleccionado.pro_scene_id = this.scenario.id;
            this.subEscenarioSeleccionado.position_sub_scenario = [];
            this.actPushSubEscenarios(this.subEscenarioSeleccionado);
          } else {
            return false;
          }
        }
      }
      this.setScenarioEmpty();
    },

    setScenarioEmpty() {
      this.editarSubScenario = false;
      this.subEscenarioSeleccionado = {
        id: null,
        pro_scene_id: this.scenario.id,
      };
    },

    seleccionarSubEscenario(sub_scenario) {
      this.editarSubScenario = true;
      this.subEscenarioSeleccionado = sub_scenario;
    },

    eliminarSubEscenario(index, sub_scenario) {
      this.$bvModal
        .msgBoxConfirm(sub_scenario.name, {
          title: "¿Está seguro de eliminar este Sub-scenario?",
          buttonSize: "lg",
          okVariant: "danger",
          okTitle: "Si",
          cancelTitle: "No",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (value) {
            this.actDelSubEscenarios(index);
          }
        });
    },

    nombreSubScenarioEsInValido() {
      return this.subEscenarioSeleccionado.name == null
        ? true
        : this.subEscenarioSeleccionado.name.trim() == "";
    },

    subScenarioRepetido() {
      this.subScenarioRepetidoStado = this.scenario.sub_scenarios.filter(
        (sub_scenario) =>
          sub_scenario.name == this.subEscenarioSeleccionado.name
      ).length;
      return this.subScenarioRepetidoStado;
    },
  },
};
</script>
<style lang="scss">
.btn-small {
  padding: 0.25rem 0.5rem !important;
  font-size: 0.875rem !important;
  line-height: 1.5 !important;
  border-radius: 0.2rem !important;
  height: 25px !important;
}

.button-nuevo {
  background: #5d5fef !important;
  border-radius: 8px !important;
  border: none !important;
  color: white !important;
}

.button-nuevo:hover {
  background: #7a7cff;
}

.button-nuevo:active {
  background: #1719da;
}
</style>
